// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { formatNumber } from '@/utilities/number';
import { Box, Typography } from '@mui/material';

interface Props {
  /** How many rows the search actually pulled back. */
  shownCount: number;
  /** How many exist to pull, so a capped page can say it is capped. */
  totalCount: number;
  /** Nothing is claimed while a search is in flight. */
  isSearching: boolean;
}

/**
 * The footer under a server-searched dropdown, telling the user when the list is
 * a capped slice so a missing row reads as "narrow the search" rather than
 * "no such record".
 */
export function SearchResultCountFooter(props: Props) {
  if (props.isSearching) {
    return null;
  }

  return (
    <Box
      sx={{
        padding: 1,
        paddingX: 2,
        borderTop: 1,
        borderColor: 'divider',
        backgroundColor: 'grey.50',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        {props.totalCount > props.shownCount
          ? `Showing ${formatNumber(props.shownCount)} / ${formatNumber(props.totalCount)} results (keep typing to refine search)`
          : 'All results displayed'}
      </Typography>
    </Box>
  );
}
